'use strict';
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useLoading } from '@/contexts/LoadingContext';

/**
 * Global loading component that shows a single spinner
 * when any component is in a loading state
 * Excludes logout modal (which has its own spinner)
 */
export const GlobalLoading = ({ showEulaModal }) => {
	const { isLoading } = useLoading();

	// Don't show if logout modal is active (it has its own spinner)
	const logoutInProgress = typeof window !== 'undefined' && localStorage.getItem('logout_in_progress') === 'true';

	// Don't show if EULA modal is active (it has its own loading state)
	if (!isLoading || logoutInProgress || showEulaModal) {
		return null;
	}

	return (
		<Box
			sx={{
				position: 'fixed',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				width: '100vw',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: 'white',
				zIndex: 9999,
				pointerEvents: 'none' // Allow clicks to pass through when not actively blocking
			}}
		>
			<CircularProgress size={40} />
		</Box>
	);
};

export default GlobalLoading;

